import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Col, } from "antd";

@inject('store')
@observer
class rooms extends Component {
    render() {
        const { selectData, onChangeTime } = this.props.store.general;
        const selected = {
            color: '#4c84ff'
        };
        return (
            <div className="rooms">
                <Row className="title">餐饮类数据</Row>
                <Row>
                    <Col span={12}>
                        <div className="total_style title_style">
                            <span>收入分布</span>
                            {/* <div>
                                <span
                                    style={selectData.income == 1 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'income', 1)}
                                >收入分类</span>
                                <span
                                    style={selectData.income == 2 ? selected : {}}
                                    onClick={onChangeTime.bind(this, 'income', 2)}
                                >收入份额</span>
                            </div> */}
                        </div>
                        <div id="food_left" style={{ height: 400, width: '100%' }} />
                    </Col>
                    <Col span={12}>
                        <div className="total_style title_style">
                            <span>收入与成本占比</span>
                            <div></div>
                        </div>
                        <div id="food_right" style={{ height: 400, width: '100%' }} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default rooms;


// WEBPACK FOOTER //
// ./src/components/BI/General/food.js